import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { MoqAggregateBusinessIdPutRequest } from '@/coreInfrastructureModule/axios/generated/aggregateBusinessManage';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';

/**
 * MOQを更新するユースケース
 */
export class PutMoqUseCase {
  private repository: IAggregateBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IAggregateBusinessRepository) {
    this.repository = repository;
  }

  /**
   * MOQを更新する
   * @param aggregateBusinessId - 集計ID
   * @param moq - MOQ
   */
  public async Execute(aggregateBusinessId: string, moq: number): Promise<INetworkResult<void, Error>> {
    const request: MoqAggregateBusinessIdPutRequest = {
      moq: moq,
    };
    try {
      const result = await this.repository.putMoq(aggregateBusinessId, request);
      switch (result.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: undefined,
            },
          };
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラー'),
        },
      };
    }
  }
}
